import React from "react";
import PropTypes from "prop-types";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import SwipeableViews from "react-swipeable-views";

// styles
import styles from "./styles-mui";

const useStyles = makeStyles(styles);

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",

    backgroundColor: "transparent",
    "& > div": {
      width: "100%",
      // backgroundColor: "white",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <div /> }} />);

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      {value === index && <React.Fragment>{children}</React.Fragment>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `nav-tab-${index}`,
    "aria-controls": `nav-tabpanel-${index}`,
  };
}

const AntTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(4),
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:hover": {
      color: "#40a9ff",
      opacity: 1,
    },
    "&$selected": {
      color: "#1890ff",
      fontWeight: theme.typography.fontWeightMedium,
    },
    "&:focus": {
      color: "#40a9ff",
    },
  },
  selected: {},
}))((props) => <TabPanel {...props}>{props.children}</TabPanel>);

export default function NavMenu({
  color,
  configTabs = [],
  value,
  onChange,
  onChangeIndex,
}) {
  const classes = useStyles({ color });
  const theme = useTheme();

  return (
    <div className={`${classes.root} ${classes.rootMarginTop2}`}>
      <AppBar className={classes.appbar} position="static">
        <StyledTabs
          variant="fullWidth"
          value={value}
          onChange={onChange}
          className={`${classes.flexContainer} ${classes.indicator}`}
          aria-label="nav tabs example"
        >
          {configTabs.map((tab, index) => (
            <Tab key={tab.id} label={tab.label} {...a11yProps(index)} />
          ))}
        </StyledTabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={value}
        onChangeIndex={onChangeIndex}
      >
        {configTabs.map((tab, index) => (
          <AntTab
            key={tab.id}
            value={value}
            index={index}
            dir={theme.direction}
          >
            {tab.page}
          </AntTab>
        ))}
      </SwipeableViews>
    </div>
  );
}
